<footer class="text-center">
  <span class="partialy-visible">
    Powered by
    <a href="https://outamation.com/" target="_blank" class="color-primary"
      >Outamation<span style="vertical-align: super; font-size: 0.8em;">
        &#174;
      </span> 
      </a
    >
  </span>
</footer>
